export default class TowerError extends Error {}



// WEBPACK FOOTER //
// ./src/TowerError.ts